function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MenuTop from './MenuTop';
import MenuContent from './MenuContent';
import MobileMenu from './MobileMenu';

var defaultLinkTemplate = function defaultLinkTemplate(_ref) {
  var url = _ref.url,
      otherProps = _objectWithoutProperties(_ref, ["url"]);

  return React.createElement("a", _extends({
    href: url
  }, otherProps));
};

var isDescendant = function isDescendant(parent, child) {
  while (child) {
    if (child === parent) {
      return true;
    }

    child = child.parentNode;
  }

  return false;
};
/**
 * Status: *In progress*.
 * Category: PageElements
 **/


var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));
    _this.state = {
      open: false,
      activeIndex: _this.props.activeIndex,
      mobileMenuOpen: false,
      openedSubmenuIndex: -1
    };
    _this.closeMobileMenu = _this.toggleMobileMenu.bind(_assertThisInitialized(_this));
    _this.onMenuHeaderItemSelected = _this.onMenuHeaderItemSelected.bind(_assertThisInitialized(_this));
    _this.toggleMobileMenu = _this.toggleMobileMenu.bind(_assertThisInitialized(_this));
    _this.toggleSubmenu = _this.toggleSubmenu.bind(_assertThisInitialized(_this));
    _this.onClickaway = _this.onClickaway.bind(_assertThisInitialized(_this));
    _this.onGlobalKeyDown = _this.onGlobalKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onClickaway);
      document.addEventListener('keydown', this.onGlobalKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClickaway);
      document.removeEventListener('keydown', this.onGlobalKeyDown);
    }
  }, {
    key: "onGlobalKeyDown",
    value: function onGlobalKeyDown(e) {
      var key = e.which || e.keyCode;

      if (key === 27 && this.state.openedSubmenuIndex !== -1) {
        // escape key
        this.toggleSubmenu(this.state.openedSubmenuIndex, e);
      }
    }
  }, {
    key: "onClickaway",
    value: function onClickaway(event) {
      if (!this.openedSubmenu) return;
      if (isDescendant(this.openedSubmenu, event.target)) return;
      this.setState({
        openedSubmenuIndex: -1
      });
      this.openedSubmenu = null;
    }
  }, {
    key: "toggleMobileMenu",
    value: function toggleMobileMenu() {
      if (!this.state.mobileMenuOpen && this.props.lockBodyOnMenuOpen) {
        document.body.classList.add('body--locked');
      } else {
        document.body.classList.remove('body--locked');
      }

      this.setState({
        mobileMenuOpen: !this.state.mobileMenuOpen
      });
    }
  }, {
    key: "onMenuHeaderItemSelected",
    value: function onMenuHeaderItemSelected(index) {
      this.setState({
        activeIndex: index
      });
    }
  }, {
    key: "toggleSubmenu",
    value: function toggleSubmenu(submenuIndex, event) {
      event.stopPropagation();

      if (this.state.openedSubmenuIndex === submenuIndex) {
        this.setState({
          openedSubmenuIndex: -1
        });
        this.openedSubmenu = null;
      } else {
        this.setState({
          openedSubmenuIndex: submenuIndex
        });
        this.openedSubmenu = event.target;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var LinkTemplate = this.props.linkTemplate || defaultLinkTemplate;
      var _this$props = this.props,
          menuLinks = _this$props.menuLinks,
          logoUrl = _this$props.logoUrl,
          logoImageDesktopPath = _this$props.logoImageDesktopPath,
          logoImageInverseDesktopPath = _this$props.logoImageInverseDesktopPath,
          logoTitle = _this$props.logoTitle,
          onSearchSubmit = _this$props.onSearchSubmit,
          isLoggedIn = _this$props.isLoggedIn,
          loginUrl = _this$props.loginUrl,
          myPageUrl = _this$props.myPageUrl,
          cartUrl = _this$props.cartUrl;
      var logo = {
        image: logoImageDesktopPath,
        imageInverted: logoImageInverseDesktopPath,
        title: logoTitle,
        url: logoUrl
      };
      return React.createElement("div", {
        className: classnames('menu', _defineProperty({}, this.props.className, this.props.className))
      }, React.createElement(MenuTop, {
        activeIndex: this.state.activeIndex,
        menuLinks: menuLinks,
        LinkTemplate: LinkTemplate,
        onMenuHeaderItemSelected: this.onMenuHeaderItemSelected
      }), React.createElement(MenuContent, {
        logo: logo,
        LinkTemplate: LinkTemplate,
        menuLink: menuLinks[this.state.activeIndex],
        onToggleSubmenu: this.toggleSubmenu,
        openedSubmenuIndex: this.state.openedSubmenuIndex,
        loginUrl: loginUrl,
        onMobileMenuToggle: this.toggleMobileMenu,
        onSearchSubmit: onSearchSubmit,
        isLoggedIn: isLoggedIn,
        myPageUrl: myPageUrl
      }), React.createElement(MobileMenu, {
        isOpen: this.state.mobileMenuOpen,
        LinkTemplate: LinkTemplate,
        onMobileMenuToggle: this.toggleMobileMenu,
        menuLinks: menuLinks,
        selectedHeaderIndex: this.state.activeIndex,
        onMenuItemSelected: this.toggleMobileMenu,
        onMenuHeaderItemSelected: this.onMenuHeaderItemSelected
      }));
    }
  }]);

  return Menu;
}(React.Component);

export { Menu as default };
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  menuLinks: PropTypes.array,
  logoImageDesktopPath: PropTypes.string,
  logoImageInverseDesktopPath: PropTypes.string,
  logoTitle: PropTypes.string,
  logoUrl: PropTypes.string,
  activeIndex: PropTypes.number,
  onSearchSubmit: PropTypes.func,
  linkTemplate: PropTypes.func,
  lockBodyOnMenuOpen: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  loginUrl: PropTypes.string,
  myPageUrl: PropTypes.string,
  cartUrl: PropTypes.string
} : {};